import React, { useState, useEffect } from 'react'
import { Tooltip, Progress, Button as AntButton } from 'antd';
import { useQuery } from "@apollo/client";
import styled from "styled-components";
import { CONNECTED_USERS } from '../../../../helpers/graphqlQueries'
import { ProgressQueries } from '../../../../helpers/GraphqlQueriesLib'
import TooltipText from './TooltipText'

// offer / looking for
// bio
// edit profile
// hacer una coneccion con otro usuario
const ProgressBar = ({ user, show }) => {

    const countMilestones = ({ user, users_connection }) => {
        let total = 0;
        let userMilestones = []
        if (users_connection?.length > 0) {
            total += 1;
            userMilestones.push(4)
        }
        if (user.preferences?.length > 0) {
            total += 1;
            userMilestones.push(2)
        }
        if (user.about?.length > 0) {
            total += 1;
            userMilestones.push(1)
        }
        if (user.can_offer?.length > 0 || user.looking_for?.length > 0) {
            total += 1;
            userMilestones.push(3)
        }
        return { total, userMilestones };
    }
    const { data: userConectionData } = useQuery(CONNECTED_USERS, { variables: { username: user.username } })
    const [progress, setProgress] = useState(0)
    const [filteredMilestones, setFilteredMilestones] = useState([])
    const [milestones, setMilestones] = useState([])
    useQuery(ProgressQueries.milestonesQuery, {
        onCompleted: ({ milestones }) =>
            setMilestones(milestones.map(value => ({ id: value.id, name: value.name, link: value.link })))
    })

    useEffect(() => {
        //console.log('connectedUsers', userConectionData)
        if (user && milestones && userConectionData) {
            const { users_connection } = userConectionData
            //console.log('connectedUsers', users_connection)
            const { total, userMilestones } = countMilestones({ user, users_connection })
            setProgress(total / milestones.length * 100)
            const filtered = milestones.map(value => {
                let milestone = { ...value }
                // console.log(value)
                milestone.approved = userMilestones.includes(value.id)
                milestone.link = (milestone.link == 'home') ? `home/${user.username}` : milestone.link;
                return milestone;
            })
            setFilteredMilestones(filtered)
        }
    }, [user, milestones, userConectionData])

    if (show) {
        return (<Container>
            <Header>Profile Progress</Header>
            <Tooltip title={(<TooltipText milestones={filteredMilestones} />)}>
                <Progress
                    strokeColor={{
                        from: '#7280da',
                        to: '#59b88d'
                    }}
                    trailColor="#c9cdd1"
                    strokeWidth={'30px'}
                    strokeLinecap="butt"
                    percent={progress}
                    //steps={50}
                />
            </Tooltip>

        </Container>)
    } else {
        return null;
    }

}

export default ProgressBar;

const Header = styled.div`
  line-height: 40px;
  font-family: "Eksell";
  font-size: ${(p) => p.size || "32px"};
  margin-bottom: 12px;
  height: 38px;
  letter-spacing: -0.4px;
  font-weight: 900;
`
const Container = styled.div`
  padding:  50px 24% ; 
  background-color:#f9f9f9;
  @media (max-width: 720px) {
    padding:  50px 10% ; 
  
  }
`